import React, { memo, forwardRef } from "react";
const SvgAddition = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 16h20M16 6v20"
      />
    </svg>
  );
});
SvgAddition.displayName = "SvgAddition";
const MemoForwardRef = memo(SvgAddition);
export default MemoForwardRef;
